import React, { FunctionComponent, useState } from "react";
import {
  POST_TYPE_ORDER,
  POST_TYPES,
  PostType,
  TOPICS,
  TopicKey,
} from "../../topics";
import { PostSnippet } from "../../types";
import { PageHeader } from "../pageHeader";
import { FilterChips } from "../filterChips";
import { PostGrid } from "../postCard";
import { EmptySection } from "../emptySection";

export interface TopicCollection {
  topic: TopicKey;
  posts: PostSnippet[];
}

type Filter = PostType | "all";

const FILTERS: { value: Filter; label: string }[] = [
  { value: "all", label: "All" },
  ...POST_TYPE_ORDER.map((type) => ({
    value: type,
    label: POST_TYPES[type].plural,
  })),
];

export const TopicCollection: FunctionComponent<TopicCollection> = ({
  topic,
  posts,
}) => {
  const [filter, setFilter] = useState<Filter>("all");
  const visible =
    filter === "all" ? posts : posts.filter((post) => post.type === filter);

  return (
    <>
      <PageHeader
        title={TOPICS[topic].name}
        deck={TOPICS[topic].description}
        topic={topic}
      >
        {posts.length > 0 && (
          <FilterChips
            label="Filter by type"
            options={FILTERS}
            selected={filter}
            onSelect={setFilter}
          />
        )}
      </PageHeader>
      <div className="px-gutter-sm pb-14 md:px-gutter">
        {visible.length > 0 ? (
          <PostGrid posts={visible} />
        ) : (
          <EmptySection topic={topic} />
        )}
      </div>
    </>
  );
};
